import "assets/scss/style.scss";

import { FC, useEffect } from "react";

import LoginForm from "features/auth/components/LoginForm";
import svgImage from "assets/img/Illustration_documents.svg";
import { useLocation, useParams } from "react-router-dom";
import Footer from "components/Footer";
// import { checkStillConnected } from "features/auth";

type LoginProps = {
    forOnlyPartner?: boolean;
    forADVEnableSSO?: boolean;
}

const Login: FC<LoginProps> = ({forOnlyPartner=false, forADVEnableSSO= true}) => {
    const location = useLocation();
    const { domainAssistant} = useParams(); // isNewUserFromWordpressAccompaniment
    const { offreIdFromWordpress} = useParams(); //offreIdFromWordpress

    useEffect(() => {
        // Check if the URL contains "professionnels"
        const hasProfessionnels = location.pathname.includes("professionnels");

        // Apply a class to the body element
        if (hasProfessionnels) {
            document.body.classList.add("professionnels");
        } else {
            document.body.classList.remove("professionnels");
        }
    }, [location]);

    return (
        <main className="login">
            <div className="login__container">
                <div className="login__form">
                    <LoginForm
                      forOnlyPartner={forOnlyPartner}
                      isNewUserFromWordpressAccompaniment={domainAssistant === 'fwa'}
                      offreIdFromWordpress={Number(offreIdFromWordpress ?? '0')}
                    />
                </div>
                <div className="login__img">
                    <img
                        src={svgImage}
                        className="illustration-document"
                        alt="Login"
                    />
                </div>
            </div>
            <Footer />
        </main>
    );
};

export default Login;
